import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_ALI_URL || 'https://api.mazesai.com/aliapi',
  timeout: 10000,
});

export default axiosInstance;
